module.exports = __webpack_public_path__ + "static/media/lol.d2e11e54.svg";